import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=21e5b161&scoped=true&lang=pug"
import script from "./HowTo.vue?vue&type=script&lang=js"
export * from "./HowTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e5b161",
  null
  
)

export default component.exports